var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionJobFunctionOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 6h4c.55 0 1.021.196 1.413.588.391.391.587.862.587 1.412v10a1.93 1.93 0 01-.587 1.413A1.928 1.928 0 0120 20H4c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 012 18V8c0-.55.196-1.02.588-1.412A1.923 1.923 0 014 6h4V4c0-.55.196-1.021.588-1.413A1.925 1.925 0 0110 2h4c.55 0 1.021.196 1.413.587.391.392.587.863.587 1.413v2zm-6-2v2h4V4h-4zM4.001 8.003l.002-.002L4.004 8h15.993l.002.002.001.001v9.994l-.001.002-.002.001H4.003v-.001L4 17.997V8.004h.001z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionJobFunctionOutline);
export default __webpack_public_path__ + "acd5b28668f9c95731ff8b1c3eeb4ca0.svg";
export { ForwardRef as ReactComponent };